import script from "./PottingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PottingTab.vue?vue&type=script&setup=true&lang=js"

import "./PottingTab.vue?vue&type=style&index=0&id=51fec6a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51fec6a9"]])

export default __exports__